
import React from 'react';

type TFileUploadFieldProps = {
  label: string;
  name: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  error?: string;
  required?: boolean;
}

export const FileUploadField: React.FC<TFileUploadFieldProps> = ({ label, name, onChange, error, required }) => (
  <div className="form-group">
    <label htmlFor={name}>{label}{required && '*'}</label>
    <input
      type="file"
      accept="application/pdf"
      id={name}
      name={name}
      onChange={onChange}
      className={`form-control fileField ${error ? 'is-invalid' : ''}`}
    />
    <span className='inputSubContext'>Sólo admite formato PDF</span>
    {error && <div className="invalid-feedback">{error}</div>}
  </div>
);
